/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Who_Title_TailInputs */

const en_services_who_title_tail = /** @type {(inputs: Services_Who_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`coaches it`)
};

const pl_services_who_title_tail = /** @type {(inputs: Services_Who_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to prowadzi`)
};

/**
* | output |
* | --- |
* | "coaches it" |
*
* @param {Services_Who_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_who_title_tail = /** @type {((inputs?: Services_Who_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Who_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_who_title_tail(inputs)
	return en_services_who_title_tail(inputs)
});